import AppLayout from '../views/layouts/AppLayout'

export default [
  {
    path: '/budget',
    name: 'budget.index',
    component: () => import('../views/budget/Index.vue'),
    meta: {
      layout: AppLayout,
      pageTitle: 'ระบบติดตามสถานะการออกเช็ค'
      // bodyClass: 'app-page'
    }
  },
  {
    path: '/budget/:id',
    name: 'budget.show',
    component: () => import('../views/budget/Show.vue'),
    meta: {
      layout: AppLayout,
      pageTitle: 'ระบบติดตามสถานะการออกเช็ค'
    }
    // children: [
    //   {
    //     path: 'year',

    //     component: () => import(/* webpackChunkName: "project_proposal_basic" */
    //   // '../components/budget/BudgetDetail.vue'
    //   '../components/budget/BudgetDetail.vue'
    //   ),
    //     meta: {
    //       title: 'ข้อมูลพื้นฐานโครงการ',
    //       layout: AppLayout
    //     }
    //   }]
  }
]
